import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Service Worker kaydı (PWA)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js');
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
